import { isEmpty } from "lodash";
import {
	PostHandler,
	QueryHandler
} from "../event-driven/core-utils/core-decorators";
import AxiosAPIInterface from "./axios-api-interface";

export const GROUP_API = {
	GET_GROUPS: "GET_GROUPS",
	GET_GROUP_MEMBERS: "GET_GROUP_MEMBERS",
	GET_ACTIVE_USERS: "GET_ACTIVE_USERS",
	ADD_GROUP: "ADD_GROUP",
	UPDATE_GROUP: "UPDATE_GROUP",
	GROUP_DELETE: "GROUP_DELETE",
	GET_GROUP_LISTING_DATA: "GET_GROUP_LISTING_DATA",
	GET_GROUPS_DROPDOWN: "GET_GROUPS_DROPDOWN"
};

export default class GroupsAPI extends AxiosAPIInterface {
	constructor() {
		if (GroupsAPI._instance) {
			return GroupsAPI._instance;
		}
		super({ resoucePath: "/groups" });
		GroupsAPI._instance = this;
	}

	@QueryHandler(GROUP_API.GET_GROUPS_DROPDOWN)
	getGroupDown({ params }) {
		return this.get({ path: "/dropdown", params: params });
	}

	@QueryHandler(GROUP_API.GET_GROUP_LISTING_DATA)
	async getGroupsList({
		select = [],
		offset = 0,
		limit = 10,
		search,
		sort,
		headers = {},
		deleted = null,
		archived = null
	}) {
		if (search) search = search.trim();
		const params = {
			offset,
			limit,
			...(select.length !== 0 && { select }),
			...(search && { searchQuery: search }),
			...(sort && { sort }),
			...(deleted && { deleted }),
			...(archived && { archived })
		};
		const response = await this.get({ params, headers });
		return {
			...response,
			groups: response.groups.map(group => ({ ...group, offset }))
		};
	}

	@QueryHandler("GET_ENTITY_DATA_MAPPED_TO_GROUP")
	getEntityDataMappedToGroup({ groupId, entities, jobStatus = {} }) {
		const params = {
			groupIds: groupId.split(","),
			entities: entities.split(","),
			...(!isEmpty(jobStatus) && {
				jobStatus: jobStatus
			})
		};
		return this.post({
			path: "/entity-mapping",
			body: params
		});
	}

	@QueryHandler(GROUP_API.GET_GROUPS)
	getGroups() {
		return this.get({ path: "/" });
	}

	@QueryHandler(GROUP_API.GET_GROUP_MEMBERS)
	getGroupMembers({ params }) {
		return this.get({ path: `/${params.id}/members`, params });
	}

	@QueryHandler(GROUP_API.GET_ACTIVE_USERS)
	getActiveUsers({ params }) {
		return this.get({ path: `/active-users`, params });
	}

	@PostHandler(GROUP_API.ADD_GROUP)
	addGroup({ payload }) {
		return this.post({ path: "/", body: payload, isDetailedResponse: true });
	}

	@QueryHandler(GROUP_API.GROUP_DELETE)
	deleteGroup(groupId) {
		return this.delete({ path: `/${groupId}` });
	}

	@PostHandler(GROUP_API.UPDATE_GROUP)
	updateGroup({ payload, groupId }) {
		// eslint-disable-next-line no-console
		console.log({ payload, groupId });
		return this.patch({ path: `/${groupId}`, body: payload });
	}
}
